<template>
	<div class="order-failed">
		<div class="center">
			<img src="/assets/images/global/order-failed.png" alt="fail" srcset="/assets/images/global/order-failed.png 1x, /assets/images/global/order-failed@2x.png 2x">
			<h1>Payment failed</h1>
			<p>
				We’re unable to proceed with your order. Click on the button<br/>
				below to try again. If the problem persists, please try<br/>
				another card for payment.
			</p>
			<CTA @click.prevent="back">Try again</CTA>
			<br/>
			<CTA class="discrete" @click.prevent="reset">Cancel</CTA>
		</div>
	</div>
</template>
<script>
import CTA from "./CTA";
export default {
	components: {CTA},
	methods: {
		back() {
			this.$router.push({name: 'confirmation-page'});
		},
		reset() {
			this.$store.dispatch('general/scrubStore');
			this.$router.push('/');
		},
	},
}
</script>
<style lang="scss">
.order-failed {
	text-align: center;
	height: calc(100vh - 8rem);
	position: relative;

	.center {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		min-width: 32rem;
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
	}

	img {
		margin-bottom: 4rem;
	}
	h1 {
		font-size: 3.6rem;
		line-height: 4.4rem;
		margin-bottom: 2rem;
	}
	p {
		font-size: 1.4rem;
		line-height: 2.1rem;
		font-weight: var(--font-weight-bold);
		color: var(--color-grey-medium);
		margin-bottom: 2rem;
	}
}
</style>
